import { useEffect, useState } from "react";

/**
 * Pie legal de las pantallas de ingreso (decisión del dueño, 2026-11-02, para la verificación de empresa en Meta): la
 * línea la arma el servidor desde appsettings `LegalNotice` en el idioma de la persona. Oculto (204) o sin respuesta,
 * no se dibuja nada y el ingreso sigue igual.
 */
export function LegalNotice() {
  const [text, setText] = useState<string | null>(null);
  useEffect(() => {
    const abort = new AbortController();
    fetch("/api/admin/legal-notice", { credentials: "same-origin", signal: abort.signal })
      .then((response) => (response.status === 200 ? (response.json() as Promise<{ text?: string }>) : null))
      .then((body) => setText(body?.text?.trim() || null))
      .catch(() => undefined);
    return () => abort.abort();
  }, []);
  return text ? (
    <footer className="auth-legal" data-part="pie-legal">
      {text}
    </footer>
  ) : null;
}
